import PageContainerMobile from 'components/PageContainer/layout/PageContainer.mobile'
import { makeStyles } from '@material-ui/core/styles'
import { Button, IconButton, TextField } from '@material-ui/core'
import { GRAY_COLORS, SUCCESS_COLORS } from 'asterX-UI'
import React, { useState } from 'react'
import { CloseIcon } from 'asterX-UI/Icons'
import CheckIcon from '@material-ui/icons/Check'
import useTaskApis from 'hooks/useTaskApis'
import { LoaderBackdrop } from 'asterX-UI/Loaders'
import { useSnackbar } from 'notistack'

const useStyles = makeStyles(() => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 16,
    marginBottom: 20
  },
  heading: {
    fontSize: 16,
    fontWeight: 600,
    lineHeight: '24px',
    marginRight: 'auto'
  },
  btns: {
    display: 'flex',
    gap: 12,
    marginTop: 32,
    fontSize: 14
  },
  round: {
    width: 70,
    height: 70,
    borderRadius: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '8px solid' + SUCCESS_COLORS['50'],
    backgroundColor: SUCCESS_COLORS['100'],
    margin: 'auto',
    marginBottom: 20
  },
  successText: {
    fontSize: 14,
    fontWeight: 600,
    display: 'flex',
    justifyContent: 'center'
  },
  cross: {
    display: 'flex',
    justifyContent: 'flex-end'
  }
}))
const CloseTaskComponent = ({
  onClose = () => {},
  taskId,
  onSave = (cb, newE) => {}
}) => {
  const { enqueueSnackbar } = useSnackbar()

  const classes = useStyles()
  const [isSuccessful, setIsSuccessful] = useState(false)
  const [result, setResult] = useState('')
  const { completeEvent, taskIsLoading } = useTaskApis()
  const onComplete =
    (newE = false) =>
    async () => {
      if (result.length >= 5) {
        await completeEvent({
          data: {
            id: taskId,
            result
          },
          onSuccess: res => {
            setIsSuccessful(true)
            onSave(newE)
          }
        })
      } else {
        enqueueSnackbar('Необходимо заполнить резельтат задачи')
      }
    }

  return !isSuccessful ? (
    <PageContainerMobile
      customHeader={
        <div className={classes.header}>
          <div className={classes.heading}>Закрытие задачи</div>
          <IconButton
            style={{
              color: GRAY_COLORS[400]
            }}
            onClick={onClose}
            size={'medium'}
          >
            <CloseIcon />
          </IconButton>
        </div>
      }
    >
      <LoaderBackdrop loading={taskIsLoading} />

      <TextField
        label={'Результат задачи'}
        multiline
        minRows={5}
        value={result}
        onChange={({ target: { value } }) => setResult(value)}
        fullWidth
      />
      <div className={classes.btns}>
        <Button
          variant={'contained'}
          fullWidth
          size={'small'}
          onClick={onComplete(true)}
        >
          Создать задачу
        </Button>
        <Button
          variant={'contained'}
          color={'primary'}
          fullWidth
          size={'small'}
          onClick={onComplete(false)}
        >
          Закрыть
        </Button>
      </div>
    </PageContainerMobile>
  ) : (
    <PageContainerMobile
      customHeader={
        <div className={classes.cross}>
          <IconButton
            style={{
              color: GRAY_COLORS[400],
              fontSize: 24
            }}
            onClick={onClose}
            size={'medium'}
          >
            <CloseIcon />
          </IconButton>
        </div>
      }
    >
      <div className={classes.round}>
        <CheckIcon style={{ fontSize: 24, color: SUCCESS_COLORS['700'] }} />
      </div>
      <div className={classes.successText}>Задача успешно закрыта</div>
    </PageContainerMobile>
  )
}

export default CloseTaskComponent
